module.exports = __webpack_public_path__ + "img/laptop.85a0145e.png";